import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function logout() {
  return Axios({
    url: `${baseUrl()}/logout`,
    method: "POST",
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
